import { render, staticRenderFns } from "./ContactTab.vue?vue&type=template&id=44a73c0e"
import script from "./ContactTab.vue?vue&type=script&lang=js"
export * from "./ContactTab.vue?vue&type=script&lang=js"
import style0 from "./ContactTab.vue?vue&type=style&index=0&id=44a73c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports